/* @flow */

import { combineReducers } from 'redux';

import availabilityReducer from 'src/shared/app/account/availability/reducer/availabilityReducer';
import oauthReducer from 'src/shared/app/account/oauth/reducer/oauthReducer';

// $FlowIssue
export default combineReducers({
  availability: availabilityReducer,
  oauth: oauthReducer,
});
